export const afterOrEqualToDate = (isoDate, compareTo) => {
    const date = new Date(isoDate);
    return date.getTime() >= compareTo.getTime();
};
